import React from "react";
import { View, StyleSheet, Platform } from "react-native";
import { Colors } from "styled42/config";
import SText from "styled42/components/SText";
import SClickableArea from "styled42/components/SClickableArea";
import S3Image from "screens/common/S3Image";
import { pushClevertapEvent } from "utils/clevertapEvents";
import VernacManager from "utils/vernacular";
import { genderEnum, genderLabel, MandatorySText } from "./utils";

const Component = ({
  isSelected,
  enumValue,
  handleStateChange,
  variant,
  vernacKey
}) => {
  const genderText = genderLabel[enumValue];

  //TODO:RENAME ICONS
  const iconName = `${genderText.toLowerCase()}_unselected${
    genderText !== "Other" ? "_new" : ""
  }`;

  return (
    <SClickableArea
      style={[
        styles.genderContainer,
        isSelected && {
          backgroundColor: Colors.Orange[1],
          borderColor: Colors.Orange[5]
        }
      ]}
      onClick={() => {
        handleStateChange({
          component: "gender",
          value: enumValue
        });
        // pushClevertapEvent("loginRegister Clicks", {
        //   Current_Page: "New loginRegistration",
        //   Page_Modal: "Personal Details",
        //   Type: `Gender - ${genderText}`
        // });
        pushClevertapEvent("loginRegister Clicks", {
          Current_Page: "New loginRegistration",
          Page_Modal: "Personal Details Page 1",
          Test_Case: variant,
          Type: `Gender - ${genderText}`
        });
      }}
    >
      <S3Image
        path="RocketIntegration"
        isLazyLoadRequired={false}
        name={iconName}
        style={styles.icon} //[styles.icon, !isSelected && styles.grayscale]
      />
      <SText
        size={12}
        color="#676574"
        containerStyle={
          isSelected && {
            color: "#000000",
            fontWeight: "bold"
          }
        }
      >
        {VernacManager.translateString(vernacKey)}
      </SText>
    </SClickableArea>
  );
};

const Label = (props) => {
  return (
    <SText>
      {VernacManager.translateString("create_account_select_gender")}{" "}
      <SText style={{ fontWeight: "bold" }}>
        {VernacManager.translateString("create_account_gender")}
      </SText>
    </SText>
  );
};

const GenderComponent = ({ value, handleStateChange, variant }) => {
  return (
    <>
      <Label />
      <View style={styles.radioFieldsParent}>
        <Component
          isSelected={value === genderEnum.MALE}
          enumValue={genderEnum.MALE}
          handleStateChange={handleStateChange}
          variant={variant}
          vernacKey="generic_male"
        />
        <Component
          isSelected={value === genderEnum.FEMALE}
          enumValue={genderEnum.FEMALE}
          handleStateChange={handleStateChange}
          variant={variant}
          vernacKey="generic_female"
        />
        <Component
          isSelected={value === genderEnum.OTHER}
          enumValue={genderEnum.OTHER}
          handleStateChange={handleStateChange}
          variant={variant}
          vernacKey="create_account_others"
        />
      </View>
    </>
  );
};

const styles = StyleSheet.create({
  icon: {
    width: 28,
    height: 28,
    marginRight: 8,
    justifyContent: "center",
    alignItems: "center"
  },
  unselectedIcon: {
    width: 28,
    height: 28,
    marginRight: 8,
    justifyContent: "center",
    alignItems: "center",
    ...Platform.select({
      web: {
        filter: "grayscale(1)"
      }
    })
  },
  grayscale: Platform.OS === "web" ? { filter: "grayscale(1)" } : {},
  radioFieldsParent: {
    flex: 1,
    marginVertical: 16,
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center"
  },
  genderContainer: {
    // flex: 1,
    flexDirection: "row",
    alignItems: "center",
    paddingVertical: 2,
    paddingHorizontal: 12,
    marginRight: 12,
    justifyContent: "space-around",
    borderColor: Colors.Grey[5],
    borderWidth: StyleSheet.hairlineWidth,
    borderRadius: 30,
    backgroundColor: "#FFFFFF"
  }
});

export default GenderComponent;
